/**
 * useAuthUser Hook
 * 
 * Provides authenticated user information for uploaders.
 * Auto-fills email and name from Supabase session when available.
 */

import { useAuth } from "../context/AuthContext";
import { isSupabaseConfigured } from "../lib/supabase";

export function useAuthUser() {
  const { user, isAuthenticated, userName } = useAuth();

  // If Supabase isn't configured or user not logged in, return nulls
  if (!isSupabaseConfigured() || !isAuthenticated || !user) {
    return {
      email: null,
      name: null,
      isAuthenticated: false,
    };
  }

  // Extract user info from Supabase user object
  // email is always available for email auth
  // userName comes from user_metadata.display_name (set via ProfileCompleteModal)
  return {
    email: user.email || null,
    name: userName || null,
    isAuthenticated: true,
  };
}

export default useAuthUser;
